import React, { useEffect, useRef, useState } from 'react';

// Drag & drop pořadí sliderů (řešení přes myš, ne HTML5 drag&drop)
function useMouseDragAndDrop(items, setItems) {
  const [draggedIdx, setDraggedIdx] = useState(null);
  const [dragOverIdx, setDragOverIdx] = useState(null);
  const [dragging, setDragging] = useState(false);

  // Mouse down na handle
  const handleMouseDown = (idx) => {
    setDraggedIdx(idx);
    setDragOverIdx(idx);
    setDragging(true);
    document.body.style.userSelect = 'none';
  };

  // Mouse enter na řádek
  const handleMouseEnter = (idx) => {
    if (dragging && draggedIdx !== null && idx !== dragOverIdx) {
      setDragOverIdx(idx);
    }
  };

  // Mouse up na řádek
  const handleMouseUp = (idx) => {
    if (dragging && draggedIdx !== null && dragOverIdx !== null) {
      if (draggedIdx !== dragOverIdx) {
        const updated = items.slice();
        const [removed] = updated.splice(draggedIdx, 1);
        updated.splice(dragOverIdx, 0, removed);
        setItems(updated);
      }
    }
    setDragging(false);
    setDraggedIdx(null);
    setDragOverIdx(null);
    document.body.style.userSelect = '';
  };

  // Mouse up mimo řádky
  React.useEffect(() => {
    if (!dragging) return;
    const onUp = () => {
      setDragging(false);
      setDraggedIdx(null);
      setDragOverIdx(null);
      document.body.style.userSelect = '';
    };
    window.addEventListener('mouseup', onUp);
    return () => window.removeEventListener('mouseup', onUp);
  }, [dragging]);

  return { draggedIdx, dragOverIdx, dragging, handleMouseDown, handleMouseEnter, handleMouseUp };
}
import { useAuth } from '../contexts/AuthContext';
import { RxCross2 } from 'react-icons/rx';
import { RxDragHandleDots2 } from 'react-icons/rx';
import styled from 'styled-components';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import Slider from 'react-slick';
import { Link } from 'react-router-dom';

const SLIDER_KEY = 'nceplus_sliders_v1';
const defaultSlides = [
  { href: '/ninjago-draci-povstani', src: 'https://i.ibb.co/t2jd3h8/NINJAGO-DP-SLIDER-2.jpg' },
  { href: '/dreamzzz', src: 'https://i.ibb.co/Kyjkn6W/DREAMZZZ-1.jpg' },
  { href: '/city-dobrodruzstvi', src: 'https://i.ibb.co/v4JFCqG/CITY-DOBRODRUZSTVI-SLIDER-NORMAL.jpg' },
  { href: '/lego-princezny-dobrodruzstvi-na-zamku', src: 'https://i.ibb.co/kQ8Dnwd/PRINCEZNY-DOBRODRUZSTVI-NA-ZAMKU-slider.jpg' },
  { href: '/star-wars-all-stars', src: 'https://i.ibb.co/8B3YkqK/ALL-STARS.jpg' },
  { href: '/star-wars-dobrodruzstvi-freemakeru', src: 'https://i.ibb.co/Nn5LQSZ/SLIDER-STAR-WARS-DOBRODRUZSTVI-FREEMAKERU.jpg' },
  { href: '/ninjago-dekodovani', src: 'https://i.ibb.co/wzwhFJr/SLIDER-NINJAGO-DEKODOVANI.jpg' },
  { href: '/star-wars-pribehy-droidu', src: 'https://i.ibb.co/vqWSkkX/SLIDER-STAR-WARS-PRIBEHY-DROIDU.jpg' },
  { href: '/atlantis', src: 'https://i.ibb.co/1nzv4t4/SLIDER-ATLANTIS.jpg' },
  { href: '/hero-factory', src: 'https://i.ibb.co/DR1y5vw/SLIDER-HERO-FACTORY.jpg' },
  { href: '/lego-dc-liga-spravedlivych-utek-z-gothamu', src: 'https://i.ibb.co/wMNp8nf/SLIDER-DC-SUPER-HRDINOVE-UTEK-Z-GOTHAMU.jpg' },
  { href: '/bionicle-maska-svetla', src: 'https://i.ibb.co/52KTNGz/SLIDER-BIONICLE-MASKA-SVETLA.jpg' },
  { href: '/ledove-kralovstvi-polarni-zare', src: 'https://i.ibb.co/105c5q5/SLIDER-LEDOVE-KRALOVSTVI-POLARNI-ZARE.jpg' },
];


export default function ImgSlider() {
  const sliderRef = useRef(null);
  const { user, role } = useAuth ? useAuth() : { user: null, role: null };
  const [editOpen, setEditOpen] = useState(false);
  const [contextPos, setContextPos] = useState(null);
  const [slides, setSlides] = useState(() => {
    try {
      const raw = localStorage.getItem(SLIDER_KEY);
      if (raw) return JSON.parse(raw);
    } catch {}
    return defaultSlides;
  });
  const [editSlides, setEditSlides] = useState(null); // null = neprobíhá editace
  const [showConfirm, setShowConfirm] = useState(false);
  // Drag & drop hook musí být vždy volán
  const dragDrop = useMouseDragAndDrop(editSlides || slides, s => setEditSlides(s));

  const settings = {
    dots: true,
    infinite: true,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 7000,
    beforeChange: (_, next) => handleSlideChange(next),
    adaptiveHeight: true,
  };

  useEffect(() => {
    // initial
    handleSlideChange(0);
    // also when mounting, slight delay to ensure slick rendered
    const t = setTimeout(() => handleSlideChange(0), 50);
    return () => clearTimeout(t);
  }, []);

  const handleSlideChange = (next) => {
    const slidesEls = document.querySelectorAll('.slick-slide');
    slidesEls.forEach((slideEl) => {
      const dataIndex = slideEl.getAttribute('data-index');
      const link = slideEl.querySelector('a');
      if (!link) return;
      const idx = dataIndex === null ? null : parseInt(dataIndex, 10);
      // enable active and immediate neighbors, disable others
      if (idx === next || idx === next - 1 || idx === next + 1) {
        link.classList.remove('disabled');
      } else {
        link.classList.add('disabled');
      }
    });
  };

  // Kontextové menu pro adminy/majitele
  const handleContextMenu = (e) => {
    if (e.target && (e.target.tagName === 'INPUT' || e.target.tagName === 'TEXTAREA')) return;
    if (role === 'Majitel' || role === 'Admin') {
      e.preventDefault();
      setEditSlides(slides.slice());
      setEditOpen(true);
    }
  };

  const handleSaveEdit = () => {
    setSlides(editSlides);
    try { localStorage.setItem(SLIDER_KEY, JSON.stringify(editSlides)); } catch {}
    setEditOpen(false);
    setEditSlides(null);
    setShowConfirm(false);
  };

  const handleCloseEdit = () => {
    if (editSlides && JSON.stringify(editSlides) !== JSON.stringify(slides)) {
      setShowConfirm(true);
    } else {
      setEditOpen(false);
      setEditSlides(null);
      setShowConfirm(false);
    }
    setContextPos(null);
  };

  return (
  <Container onContextMenu={handleContextMenu} style={{ userSelect: 'none' }}>
      <Carousel ref={sliderRef} {...settings}>
        {slides.map((s, i) => (
          <Wrap key={i}>
            {s.href ? (
              <Link to={s.href} className="btn">
                <img src={s.src} alt="" loading="eager" />
              </Link>
            ) : (
              <img src={s.src} alt="" loading="eager" />
            )}
          </Wrap>
        ))}
      </Carousel>
      {editOpen && (
        <div
          style={{
            position: 'fixed',
            inset: 0,
            zIndex: 10000,
            background: 'rgba(0,0,0,0.55)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
          onClick={handleCloseEdit}
        >
          <div
            style={{
              background: '#181c22',
              color: '#fff',
              borderRadius: 12,
              boxShadow: '0 8px 32px rgba(0,0,0,0.45)',
              padding: 32,
              minWidth: 420,
              maxWidth: '98vw',
              maxHeight: '90vh',
              overflowY: 'auto',
              position: 'relative',
            }}
            onClick={e => e.stopPropagation()}
          >
            {/* Horní lišta s uložit a zavřít */}
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 18 }}>
              <div style={{ fontWeight: 700, fontSize: 22 }}>Editace sliderů</div>
              <div style={{ display: 'flex', gap: 8 }}>
                <button
                  onClick={handleSaveEdit}
                  style={{ background: '#2d8a34', color: '#fff', border: 'none', borderRadius: 4, padding: '8px 16px', fontWeight: 700, cursor: 'pointer' }}
                >Uložit</button>
                <button
                  onClick={handleCloseEdit}
                  style={{
                    width: 36,
                    height: 36,
                    borderRadius: '50%',
                    border: 'none',
                    background: 'rgba(255,255,255,0.08)',
                    color: '#fff',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    cursor: 'pointer',
                    fontSize: 24,
                    zIndex: 2
                  }}
                  title="Zavřít"
                >
                  <RxCross2 color="#fff" size={24} />
                </button>
              </div>
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
              {(editSlides||[]).map((s, i) => {
                const srcRef = React.createRef();
                const hrefRef = React.createRef();
                const isDragged = dragDrop.draggedIdx === i && dragDrop.dragging;
                const isOver = dragDrop.dragOverIdx === i && dragDrop.dragging && dragDrop.draggedIdx !== dragDrop.dragOverIdx;
                return (
                  <div
                    key={i}
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: 8,
                      background: isDragged ? '#2d8a34' : isOver ? '#3a3f4a' : '#232733',
                      borderRadius: 6,
                      padding: 10,
                      opacity: isDragged ? 0.7 : 1,
                      boxShadow: isDragged ? '0 0 0 2px #2d8a34' : isOver ? '0 0 0 2px #3a3f4a' : undefined,
                      cursor: dragDrop.dragging ? 'grabbing' : 'grab',
                      transition: 'background 0.15s, box-shadow 0.15s, opacity 0.15s',
                    }}
                    onMouseEnter={() => dragDrop.handleMouseEnter(i)}
                    onMouseUp={() => dragDrop.handleMouseUp(i)}
                    onClick={e => {
                      if (e.target === e.currentTarget && srcRef.current) srcRef.current.focus();
                    }}
                  >
                    {/* Drag handle - pouze vizuální, skutečný drag začíná na mouseDown zde */}
                    <span
                      style={{ cursor: 'grab', display: 'flex', alignItems: 'center', userSelect: 'none', marginRight: 2 }}
                      title="Přetáhni pro změnu pořadí"
                      onMouseDown={e => { e.preventDefault(); dragDrop.handleMouseDown(i); }}
                    >
                      <RxDragHandleDots2 color="#aaa" size={22} />
                    </span>
                    <span style={{ fontWeight: 700, color: '#aaa', minWidth: 22, textAlign: 'center', userSelect: 'none' }}>{i + 1}</span>
                    <input
                      ref={srcRef}
                      type="text"
                      value={s.src}
                      onChange={e => {
                        const next = (editSlides||[]).slice();
                        next[i] = { ...next[i], src: e.target.value };
                        setEditSlides(next);
                      }}
                      style={{ flex: 2, padding: '6px 10px', borderRadius: 4, border: '1px solid #444', background: '#181c22', color: '#fff' }}
                      placeholder="URL obrázku"
                      onContextMenu={e => e.stopPropagation()}
                      onClick={e => e.currentTarget.focus()}
                    />
                    <input
                      ref={hrefRef}
                      type="text"
                      value={s.href}
                      onChange={e => {
                        const next = (editSlides||[]).slice();
                        next[i] = { ...next[i], href: e.target.value };
                        setEditSlides(next);
                      }}
                      style={{ flex: 2, padding: '6px 10px', borderRadius: 4, border: '1px solid #444', background: '#181c22', color: '#fff' }}
                      placeholder="Cílová URL (nepovinné)"
                      onContextMenu={e => e.stopPropagation()}
                      onClick={e => e.currentTarget.focus()}
                    />
                    <button
                      style={{ background: '#a33', color: '#fff', border: 'none', borderRadius: 4, padding: '6px 12px', fontWeight: 600, cursor: 'pointer' }}
                      onClick={() => {
                        const next = (editSlides||[]).slice();
                        next.splice(i, 1);
                        setEditSlides(next);
                      }}
                      title="Smazat tento slider"
                    >Smazat</button>
                  </div>
                );
              })}
              <button
                style={{ background: '#2d8a34', color: '#fff', border: 'none', borderRadius: 4, padding: '8px 16px', fontWeight: 700, cursor: 'pointer', marginTop: 8 }}
                onClick={() => setEditSlides([...(editSlides||[]), { href: '', src: '' }])}
              >Přidat nový slider</button>
            </div>
            {/* Potvrzovací dialog při zavření s neuloženými změnami */}
            {showConfirm && (
              <div style={{
                position: 'fixed',
                inset: 0,
                background: 'rgba(0,0,0,0.55)',
                zIndex: 10001,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}>
                <div style={{ background: '#232733', borderRadius: 10, padding: 32, minWidth: 320, maxWidth: '90vw', boxShadow: '0 4px 24px #0008', color: '#fff' }}>
                  <div style={{ fontWeight: 700, fontSize: 18, marginBottom: 18 }}>Neuložené změny</div>
                  <div style={{ marginBottom: 18 }}>Chceš změny uložit, zahodit, nebo pokračovat v úpravách?</div>
                  <div style={{ display: 'flex', gap: 18, justifyContent: 'center', marginTop: 8 }}>
                    <button onClick={handleSaveEdit} style={{ background: '#2d8a34', color: '#fff', border: 'none', borderRadius: 4, padding: '10px 22px', fontWeight: 700, cursor: 'pointer', minWidth: 100 }}>Uložit</button>
                    <button onClick={() => { setEditOpen(false); setEditSlides(null); setShowConfirm(false); }} style={{ background: '#a33', color: '#fff', border: 'none', borderRadius: 4, padding: '10px 22px', fontWeight: 700, cursor: 'pointer', minWidth: 100 }}>Zahodit</button>
                    <button onClick={() => setShowConfirm(false)} style={{ background: '#444', color: '#fff', border: 'none', borderRadius: 4, padding: '10px 22px', fontWeight: 700, cursor: 'pointer', minWidth: 100 }}>Pokračovat v úpravách</button>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      )}
    </Container>
  );
}

const Container = styled.div`
  padding: 0 calc(3.5vw + 5px);
`;

const Carousel = styled(Slider)`
  position: relative;
  margin-top: 10px;

  .slick-slide {
    padding: 10px;
    transition: opacity 0.5s ease;
  }

  /* šipky: vertikálně vycentrovat a sjednotit vzhled */
  .slick-prev,
  .slick-next {
    top: 60% !important;
    transform: translateY(-50%) !important;
    width: 26px;
    height: 26px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    z-index: 3;
  }

  .slick-prev { left: 16px !important; }
  .slick-next { right: 24px !important; margin-right: 0; }

  /* zajistit dobře čitelné šipky (přepíšeme default pseudo) */
  .slick-prev:before,
  .slick-next:before {
    color: #fff;
    font-size: 16px;
    opacity: 1;
  }

  .slick-slide:not(.slick-active) { opacity: 0.1; }
  /* Disable interaction on non-active slides so they are not clickable */
  .slick-slide:not(.slick-active) a { pointer-events: none; cursor: default; }
  .slick-active { cursor: pointer; opacity: 1; }

  ul.slick-dots {
    position: absolute;
    bottom: 18px;
    right: 24px;
    display: flex !important;
    justify-content: flex-end;
    align-items: center;
    z-index: 3;
    pointer-events: none;
  }

  ul.slick-dots li { margin: 0 6px; pointer-events: auto; }

  /* odstraníme defaultní ::before puntík a stylujeme samotné tlačítko */
  ul.slick-dots li button {
    width: 10px;
    height: 10px;
    padding: 0;
    border-radius: 50%;
    background: rgba(255,255,255,0.22);
    border: none;
    position: relative;
  }
  ul.slick-dots li button:before { display: none; }

  /* aktivní puntík */
  ul.slick-dots li.slick-active button {
    background: #ffffff;
    box-shadow: 0 0 0 6px rgba(255,255,255,0.04);
  }

  .slick-list { overflow: visible; }
`;

const Wrap = styled.div`
  background: linear-gradient(rgb(48, 50, 62), rgb(30, 31, 42));
  border-radius: 4px;

  a.disabled { pointer-events: none; cursor: default; }

  img {
    object-fit: cover;
    outline: 0px solid transparent;
    border-radius: 4px;
    width: 100%;
    height: 100%;
    box-shadow: rgb(0 0 0 / 69%) 0px 26px 30px -10px, rgb(0 0 0 / 73%) 0px 16px 10px -10px;
    transition-duration: 250ms;
  }

  img:hover { outline: 4px solid rgba(249, 249, 249, 0.8); }
`;

const SliderWrapper = styled.div`
  width: 100%;
  height: auto;
  max-height: calc(100vh - var(--header-height, 80px) - var(--footer-height, 0px));
  overflow: hidden;
  position: relative;
  box-sizing: border-box;
  margin: 0; /* odstraní svislé marginy, které mohou vytvářet overflow */
`;

const Slide = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0; /* důležité */
  box-sizing: border-box;

  img {
    width: 100%;
    height: 100%;
    max-height: calc(100vh - var(--header-height, 80px) - var(--footer-height, 0px));
    object-fit: cover;
    display: block;
  }
`;